// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"0b31db18","137":"8481e8e7","152":"8af1ad3a","205":"eee7f377","453":"0f814f54","467":"0ba960b5","984":"79a3f9d3"}[chunkId] + ".chunk.js";
};